/**
 * Supply system ("Versorgungssystem") helpers (#1784).
 *
 * The ZeoVit module (tile, sidebar entry, Aufgaben card, /zeovit-recommendations pages)
 * is only offered for aquariums whose supply system is ZeoVit. The stored value is the
 * AquariumForm option `zeovit`; it is compared trimmed and case-insensitively, exactly
 * like the backend gate (src/services/zeovitSupplySystem.ts).
 */

export const ZEOVIT_SUPPLY_SYSTEM = 'zeovit';

/** Error code the ZeoVit write routes answer (409) for a non-ZeoVit aquarium. */
export const SUPPLY_SYSTEM_NOT_ZEOVIT = 'SUPPLY_SYSTEM_NOT_ZEOVIT';

/** True when a supply system value means ZeoVit (trimmed, case-insensitive). */
export function isZeovitSupplySystem(value: string | null | undefined): boolean {
  return typeof value === 'string' && value.trim().toLowerCase() === ZEOVIT_SUPPLY_SYSTEM;
}

/** Where the supply system of an aquarium is changed: the aquarium list opens its edit form. */
export function aquariumSettingsPath(aquariumId: string): string {
  return `/aquariums?edit=${encodeURIComponent(aquariumId)}`;
}
